import React, { useState, useEffect } from 'react';
import axios from 'axios'

    const VenueAreas = ({ sessionData, BASE_URL, INVITES_API }) => {

    const [areas, setAreas] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const BASEURL = `${BASE_URL}banquets`;
    const APIURL = `${INVITES_API}api`

    useEffect(() => {
        const controller = new AbortController(); // Create an abort controller

        const fetchAreas = async () => {
        try {
            const response = await axios.get(
            `${APIURL}/city-page/areas/${sessionData.CityId}`,
            { signal: controller.signal }
            );
            
            setAreas(response.data);
        } catch (error) {
            if (error.name !== "AbortError") {
            console.error("Error fetching Areas:", error);
            }
        } finally {
            setIsLoading(false);
        }
        };

        fetchAreas();

        return () => controller.abort(); // Cleanup: cancel the request if the component unmounts
    }, []);

    return (
        <>
        { isLoading || areas.length === 0 ? (
            ""
        ) : (
            <>
            <section className="venue-areas">
                <div className="areas-container">
                    <h2 className="areas-title">Browse Venues in {sessionData.CityName} by Area</h2>
                    <p className="areas-subtitle">Find the best options in your area</p>
                    <div className="areas-grid">
                    {areas.map((area, index) => (
                        <a href={`${BASEURL}/${sessionData.CityUniqueLink}/${area.AreaUniqueLink}`} key={index} className="area-button" target='_blank'  >
                        {area.AreaName}
                        </a>
                    ))}
                    
                    </div>
                </div>
            </section>
            </>
        ) }
        
        </>
    );
    };

    export default VenueAreas;